import { Map } from 'immutable';
import { type AnyAction } from 'redux';

import type DonationMatchingRule from 'entities/donationMatchingRule/model';

import { ADD, ADD_MULTIPLE, UPDATE, REMOVE } from './constants';

export type DonationMatchingRuleState = Map<string, DonationMatchingRule>;

const initialState = Map<string, DonationMatchingRule>();

export default (
  state: DonationMatchingRuleState = initialState,
  action: AnyAction
): DonationMatchingRuleState => {
  switch (action.type) {
    case ADD:
      return state.set(action.donationMatchingRule.id, action.donationMatchingRule);

    case ADD_MULTIPLE:
      return state.merge(action.donationMatchingRules);

    case UPDATE:
      return state.set(action.donationMatchingRule.id, action.donationMatchingRule);

    case REMOVE:
      return state.delete(action.id);

    case 'RESET':
      return initialState;

    default:
      return state;
  }
};
